module.exports = __webpack_public_path__ + "img/process-header.75def4c5.webp";